import React, { useState } from 'react';
import { TextField, makeStyles } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import PropTypes from 'prop-types';
import axios from 'axios';
import AllowedCities from '../../static/files/AllowedCities.json';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiAutocomplete-input': {
      padding: `${theme.overrides.MuiInputBase.input.padding} !important`,
    },
  },
  adornment: {
    '& .MuiAutocomplete-endAdornment': {
      right: '24px',
    },
    '& .MuiInputAdornment-positionEnd': {
      position: 'absolute',
      right: 0,
    },
  },
}));

const AutocompleteCityUF = ({
  textfieldlabel, InputProps, placeholder, InputLabelProps, onChange, justWeServe, helperText, error, ...rest
}) => {
  const classes = useStyles();
  const [cities, setCities] = useState([]);

  const renderOptionLabel = (option) => ((option && option.name && option.stateInitial)
    ? `${option.name} / ${option.stateInitial}`
    : '');

  const handleChange = (value) => {
    axios.get(`${process.env.GATSBY_ABRIR_EMPRESA_BASE_URL}/util/city?name=${value}`)
      .then((response) => {
        if (response && response.data && response.data.cities) {
          setCities(response.data.cities);
        }
      })
      .catch(() => setCities([]));
  };

  return (
    <Autocomplete
      options={justWeServe ? AllowedCities.cities : cities}
      getOptionLabel={renderOptionLabel}
      value={rest.value || null}
      onChange={(event, newValue) => onChange(newValue)}
      onInputChange={justWeServe ? null : (event, value) => handleChange(value)}
      className={classes.root}
      renderInput={(params) => {
        params.inputProps.autoComplete = 'none';
        return (
          <TextField
            {...params}
            label={textfieldlabel}
            error={error}
            placeholder={placeholder}
            helperText={helperText}
            InputLabelProps={InputLabelProps}
            name="cidade_estado"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <div className={classes.adornment} style={{ display: 'flex', alignItems: 'center' }}>
                  {params.InputProps.endAdornment}
                  {InputProps.endAdornment}
                </div>
              ),
            }}
          />
        );
      }}
      {...rest}
    />
  );
};

AutocompleteCityUF.defaultProps = {
  textfieldlabel: 'Cidade / Estado',
  noOptionsText: 'Localização não encontrada',
  onChange: () => {},
  justWeServe: true,
};

AutocompleteCityUF.propTypes = {
  textfieldlabel: PropTypes.string,
  noOptionsText: PropTypes.string,
  onChange: PropTypes.func,
  justWeServe: PropTypes.bool,
  InputProps: PropTypes.shape().isRequired,
};

export default AutocompleteCityUF;
